import type { FC } from 'react';

/* ---- #app ---- */
export const AppSection: FC = () => (
  <section id="app" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
        <div className="flex-1 text-center lg:text-left">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            随时随地
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            91樱花移动端访问
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md mx-auto lg:mx-0">
            无需下载APP，手机浏览器直接打开91樱花官网网址即可畅享全部动漫资源。自适应移动端界面，流量消耗低，加载速度快，让你随时随地追番看动漫。
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-3">
            <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg border border-background-200/80">
              <div className="w-7 h-7 flex items-center justify-center text-accent-500">
                <i className="ri-smartphone-line text-lg"></i>
              </div>
              <span className="text-xs text-foreground-600 whitespace-nowrap">手机浏览器直接访问</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg border border-background-200/80">
              <div className="w-7 h-7 flex items-center justify-center text-accent-500">
                <i className="ri-speed-up-line text-lg"></i>
              </div>
              <span className="text-xs text-foreground-600 whitespace-nowrap">极速加载体验</span>
            </div>
          </div>
        </div>
        <div className="flex-1 flex justify-center">
          <div className="relative w-48 h-80 bg-background-50 rounded-3xl border-4 border-background-300 overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-6 bg-background-200 flex items-center justify-center">
              <div className="w-16 h-1 rounded-full bg-background-400"></div>
            </div>
            <div className="pt-8 px-3 flex flex-col gap-3">
              <div className="h-3 w-20 rounded-full bg-primary-200 mx-auto"></div>
              <div className="h-24 rounded-lg bg-background-100"></div>
              <div className="h-3 w-full rounded-full bg-background-200"></div>
              <div className="h-3 w-3/4 rounded-full bg-background-200"></div>
              <div className="h-16 rounded-lg bg-background-100"></div>
              <div className="h-16 rounded-lg bg-background-100"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-10 bg-background-50 border-t border-background-200 flex items-center justify-around px-2">
              <div className="w-5 h-5 rounded bg-primary-300"></div>
              <div className="w-5 h-5 rounded bg-background-300"></div>
              <div className="w-5 h-5 rounded bg-background-300"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ---- #topics ---- */
const TOPICS = [
  { tag: '2026夏季新番', heat: '9.8万', color: 'bg-primary-100 text-primary-700' },
  { tag: '经典老番回顾', heat: '8.5万', color: 'bg-accent-100 text-accent-700' },
  { tag: '热血冒险', heat: '12.3万', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '恋爱日常', heat: '10.1万', color: 'bg-primary-100 text-primary-700' },
  { tag: '奇幻异世界', heat: '11.6万', color: 'bg-accent-100 text-accent-700' },
  { tag: '悬疑推理', heat: '7.2万', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '治愈系动漫', heat: '9.0万', color: 'bg-primary-100 text-primary-700' },
  { tag: '国漫精选', heat: '8.8万', color: 'bg-accent-100 text-accent-700' },
  { tag: '剧场版动画', heat: '6.5万', color: 'bg-secondary-100 text-secondary-700' },
];

export const TopicsSection: FC = () => (
  <section id="topics" className="py-14 md:py-20 bg-background-50">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
          热门话题
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          大家都在看什么
        </h2>
        <p className="mt-2 text-sm text-foreground-500">探索当前最受欢迎的动漫话题标签</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {TOPICS.slice(0, 5).map((item, i) => (
          <a
            key={i}
            href="#ranking"
            className="relative group flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200"
          >
            <span className={`inline-block px-3 py-1.5 rounded-full ${item.color} text-xs font-semibold whitespace-nowrap`}>
              {item.tag}
            </span>
            <span className="text-xs text-foreground-400">
              <i className="ri-fire-line mr-1"></i>
              {item.heat}
            </span>
          </a>
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-3">
        {TOPICS.slice(5, 9).map((item, i) => (
          <a
            key={i}
            href="#ranking"
            className="relative group flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200"
          >
            <span className={`inline-block px-3 py-1.5 rounded-full ${item.color} text-xs font-semibold whitespace-nowrap`}>
              {item.tag}
            </span>
            <span className="text-xs text-foreground-400">
              <i className="ri-fire-line mr-1"></i>
              {item.heat}
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #updates ---- */
const UPDATES = [
  {
    date: '07-30',
    title: '2026夏季新番《剑风传说》第3季今日更新至第8话',
    tag: '新番速递',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-29',
    title: '《星辰变》剧场版确认2026年冬季上映，官方预告片已发布',
    tag: '剧场版',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-28',
    title: '官方发布91樱花全新永久域名，请及时更新收藏地址',
    tag: '站点公告',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-27',
    title: '《异世界悠闲农家》第二季制作决定，预计2027年春播出',
    tag: '续作确认',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-26',
    title: '网站服务器完成全面升级，访问速度与稳定性整体提升40%',
    tag: '站点公告',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-25',
    title: '《灵笼》第二季第6话今日准时上线，剧情进入高潮',
    tag: '新番速递',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-24',
    title: '91樱花新增4K高清资源专区，多部热门作品已完成上架',
    tag: '站点公告',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-23',
    title: '《黑执事》新作动画定档2026年秋季，首支PV曝光',
    tag: '定档消息',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-22',
    title: '防封系统升级至3.0版本，访问更稳定更安全',
    tag: '站点公告',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export const UpdatesSection: FC = () => (
  <section id="updates" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
          最新动态
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          动漫资讯快讯
        </h2>
        <p className="mt-2 text-sm text-foreground-500">每日更新最新动漫资讯与站点公告</p>
      </div>
      <div className="max-w-3xl mx-auto space-y-0">
        {UPDATES.map((item, i) => (
          <div
            key={i}
            className={`flex items-start gap-4 px-4 py-4 border-b border-background-200/60 last:border-b-0 hover:bg-background-50 transition-colors ${
              i === 0 ? 'pt-0' : ''
            }`}
          >
            <span className="text-xs text-foreground-400 font-mono whitespace-nowrap mt-0.5">
              {item.date}
            </span>
            <span className={`inline-block px-2 py-0.5 rounded text-[11px] font-semibold whitespace-nowrap mt-0.5 ${item.tagColor}`}>
              {item.tag}
            </span>
            <span className="text-sm text-foreground-800 leading-relaxed flex-1">
              {item.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #ranking ---- */
const RANKING = [
  { rank: 1, title: '剑风传说 第3季', heat: '156.2万', status: '更新至第8话', trend: 'up' },
  { rank: 2, title: '星辰变', heat: '142.8万', status: '剧场版制作中', trend: 'up' },
  { rank: 3, title: '灵笼 第2季', heat: '128.5万', status: '更新至第6话', trend: 'hot' },
  { rank: 4, title: '异世界悠闲农家', heat: '115.3万', status: '第二季决定', trend: 'up' },
  { rank: 5, title: '黑执事 新作', heat: '98.7万', status: '2026秋播出', trend: 'new' },
  { rank: 6, title: '鬼灭之刃 无限城篇', heat: '87.4万', status: '持续更新中', trend: 'up' },
  { rank: 7, title: '葬送的芙莉莲 第2季', heat: '76.1万', status: '人气连载中', trend: 'up' },
];

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-white',
  2: 'bg-accent-400 text-white',
  3: 'bg-accent-300 text-accent-900',
};

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-green-500',
  hot: 'ri-fire-line text-red-500',
  new: 'ri-sparkling-line text-accent-500',
};

export const RankingSection: FC = () => (
  <section id="ranking" className="py-14 md:py-20 bg-background-50">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
          热度榜单
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          本周热门排行
        </h2>
        <p className="mt-2 text-sm text-foreground-500">根据浏览量与讨论热度实时更新</p>
      </div>
      <div className="max-w-2xl mx-auto space-y-2">
        {RANKING.map((item) => (
          <div
            key={item.rank}
            className="flex items-center gap-4 px-5 py-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-200"
          >
            <div
              className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                rankColors[item.rank] || 'bg-background-100 text-foreground-500'
              }`}
            >
              {item.rank}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
              <p className="text-xs text-foreground-400 mt-0.5">{item.status}</p>
            </div>
            <div className="flex items-center gap-1.5 flex-shrink-0">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={trendIcons[item.trend]}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">{item.heat}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #carousel ---- */
const CAROUSEL_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20warrior%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20kingdom%20at%20sunset%2C%20cherry%20blossom%20petals%20floating%2C%20epic%20cinematic%20lighting%2C%20warm%20golden%20and%20pink%20tones%2C%20highly%20detailed%20illustration&width=600&height=380&seq=carousel-01-sakura&orientation=landscape',
    tag: '2026夏季新番',
    title: '剑风传说 第3季',
    desc: '史诗级冒险再开，全新篇章引爆夏日热潮',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20mystical%20starry%20sky%20above%20an%20ancient%20temple%20with%20floating%20crystals%2C%20soft%20magical%20glow%2C%20deep%20cosmic%20colors%20with%20warm%20gold%20accents%2C%20dreamy%20atmosphere%2C%20highly%20detailed%20fantasy%20illustration&width=600&height=380&seq=carousel-02-sakura&orientation=landscape',
    tag: '剧场版',
    title: '星辰变 剧场版',
    desc: '2026年冬季上映，官方预告片已震撼发布',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20post-apocalyptic%20cityscape%20with%20giant%20mechanical%20structures%2C%20a%20group%20of%20survivors%20in%20silhouette%2C%20dramatic%20orange%20and%20teal%20lighting%2C%20sci-fi%20aesthetic%20with%20warm%20undertones%2C%20highly%20detailed&width=600&height=380&seq=carousel-03-sakura&orientation=landscape',
    tag: '国创动画',
    title: '灵笼 第2季',
    desc: '末世科幻巨制，每一帧都是视觉盛宴',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20peaceful%20countryside%20farm%20with%20a%20cozy%20wooden%20house%2C%20vegetable%20garden%20and%20magical%20creatures%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20soft%20pastel%20colors%2C%20relaxing%20slice-of-life%20aesthetic&width=600&height=380&seq=carousel-04-sakura&orientation=landscape',
    tag: '续作确认',
    title: '异世界悠闲农家',
    desc: '治愈系日常番第二季来袭，2027年春播出',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20Victorian%20gothic%20mansion%20interior%20with%20a%20mysterious%20butler%20silhouette%2C%20moonlight%20streaming%20through%20stained%20glass%20windows%2C%20dark%20elegant%20atmosphere%20with%20hints%20of%20warm%20candlelight%2C%20detailed%20illustration&width=600&height=380&seq=carousel-05-sakura&orientation=landscape',
    tag: '定档消息',
    title: '黑执事 新作',
    desc: '经典回归，2026年秋季动画化确定',
  },
];

export const CarouselSection: FC = () => (
  <section id="carousel" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
          焦点专题
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          本期特别推荐
        </h2>
        <p className="mt-2 text-sm text-foreground-500">精选当前最值得关注的动漫作品</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CAROUSEL_ITEMS.slice(0, 3).map((item, i) => (
          <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-[11px] font-semibold">
                {item.tag}
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
        {CAROUSEL_ITEMS.slice(3, 5).map((item, i) => (
          <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-[11px] font-semibold">
                {item.tag}
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #contact ---- */
export const ContactSection: FC = () => (
  <section id="contact" className="py-14 md:py-20 bg-background-50">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
          联系我们
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          投稿与商务合作
        </h2>
        <p className="mt-2 text-sm text-foreground-500">欢迎动漫创作者、UP主与商业伙伴联系我们</p>
      </div>
      <div className="max-w-xl mx-auto">
        <div className="rounded-2xl bg-background-50 border border-background-200/60 p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100">
            <i className="ri-mail-send-line text-2xl text-accent-600"></i>
          </div>
          <h3 className="text-lg font-bold text-foreground-900 mb-3">投稿与商务洽谈</h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6">
            如果你有优质动漫内容创作、资源分享或商务合作需求，欢迎通过以下方式与我们取得联系。91樱花期待与你携手打造更精彩的动漫社区。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-6 h-6 flex items-center justify-center text-primary-500">
                <i className="ri-mail-line"></i>
              </div>
              <span className="text-sm text-foreground-600">contact@91sakura.com</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-6 h-6 flex items-center justify-center text-accent-500">
                <i className="ri-discord-line"></i>
              </div>
              <span className="text-sm text-foreground-600">91樱花官方社区</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);